export const VISUALIZATION_MODE = 'VISUALIZATION_MODE'
export const CART_SELECTION_MODE = 'CART_SELECTION_MODE'
export const ACCOUNT_EDIT_MODE = 'ACCOUNT_EDIT_MODE'
export const HISTORIAL_ORDERS = 'HISTORIAL_ORDERS'
export const ADD_MODE = 'ADD_MODE'
